import React, { createRef } from "react";
import ReactDOM from "react-dom";
import logo from "./icons/hsbc.svg";
import "./header.css";

// This is the Main Header component
// This just pulls all the parts into one place for rendering
// Nothing should need to change here
class MainHeader extends React.Component {
  constructor() {
    super();
    this.upperLogon = createRef();
    this.lowerLogon = createRef();
    this.state = {
      showMobileMenu: false,
      showMobileMenuDropdown: false,
      showUpperLogOn: false,
      showLowerLogOn: false,
    };
  }
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutsideLogOn);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutsideLogOn);
  }
  handleUpperLogOn = (event) => {
    const logOnMenu = event.currentTarget;
    const logOnMenuDropDown = logOnMenu.querySelector(
      ".upper-header__log-on-menu"
    );
    if (!logOnMenu.classList.contains("active")) {
      logOnMenu.classList.add("active");
      logOnMenuDropDown.classList.add("active");
      this.setState({ showUpperLogOn: true });
    } else {
      logOnMenu.classList.remove("active");
      logOnMenuDropDown.classList.remove("active");
      this.setState({ showUpperLogOn: false });
    }
  };
  handleLowerLogOn = (event) => {
    const logOnMenu = event.currentTarget;
    const logOnMenuDropDown = logOnMenu.querySelector(
      ".lower-header__log-on-menu"
    );
    if (!logOnMenu.classList.contains("active")) {
      logOnMenu.classList.add("active");
      logOnMenuDropDown.classList.add("active");
      this.setState({ showLowerLogOn: true });
    } else {
      logOnMenu.classList.remove("active");
      logOnMenuDropDown.classList.remove("active");
      this.setState({ showLowerLogOn: false });
    }
  };
  handleClickOutsideLogOn = (event) => {
    if (this.upperLogon && !this.upperLogon.current.contains(event.target)) {
      document
        .querySelector(".upper-header__log-on")
        .classList.remove("active");
      document
        .querySelector(".upper-header__log-on-menu")
        .classList.remove("active");
      this.setState({ showUpperLogOn: false });
    }

    if (this.lowerLogon && !this.lowerLogon.current.contains(event.target)) {
      document
        .querySelector(".lower-header__log-on")
        .classList.remove("active");
      document
        .querySelector(".lower-header__log-on-menu")
        .classList.remove("active");
      this.setState({ showLowerLogOn: false });
    }
  };
  handleNavDropDownMenu = (event) => {
    const menuItem = event.currentTarget;
    const menu = menuItem.querySelector(".lower-header__dropdown-menu");
    if (!menu.classList.contains("active")) {
      menu.classList.add("active");
    } else {
      menu.classList.remove("active");
      menuItem.classList.remove("clicked");
    }
  };
  handleNavDropDownMenuFocus = (event) => {
    const menuItem = event.currentTarget;
    if (!menuItem.classList.contains("clicked")) {
      menuItem.classList.add("clicked");
    } else {
      menuItem.classList.remove("clicked");
    }
  };
  handleMobileMenu = (event) => {
    this.setState({
      showMobileMenu: !this.state.showMobileMenu,
    });
    if (this.state.showMobileMenu) {
      document.querySelector("body").classList.remove("side-menu__open");
      if (document.querySelector(".side-menu__menu-item.active")) {
        this.handleMobileMenuBack(event);
      }
    } else {
      document.querySelector("body").classList.add("side-menu__open");
    }
  };
  handleMobileMenuBack = (event) => {
    if (event.currentTarget.classList.contains("left-arrow")) {
      event.stopPropagation();
    }
    document
      .querySelector(".side-menu__menu-item.active")
      .classList.remove("active");
    document
      .querySelector(".side-menu__menu-open.active")
      .classList.remove("active");
    document
      .querySelector(".side-menu__menu-item--register")
      .classList.remove("hide");
    this.setState({
      showMobileMenuDropdown: false,
    });
  };
  handleMobileMenuExtension = (event) => {
    const menuItem = event.currentTarget;
    const menu = menuItem.querySelector(".side-menu__menu-open");
    if (
      document.querySelector(".side-menu__menu-item.active") &&
      !menuItem.classList.contains("active")
    ) {
      document
        .querySelector(".side-menu__menu-item.active")
        .classList.remove("active");
      document
        .querySelector(".side-menu__menu-open.active")
        .classList.remove("active");
    }
    if (!menu.classList.contains("active")) {
      menu.classList.add("active");
      menuItem.classList.add("active");
      menu.querySelector("a").focus();
      document
        .querySelector(".side-menu__menu-item--register")
        .classList.add("hide");
      this.setState(() => ({
        showMobileMenuDropdown: true,
      }));
    } else {
      menu.classList.remove("active");
      menuItem.classList.remove("active");
      this.setState({
        showMobileMenuDropdown: false,
      });
    }
  };
  handleClickOnOverlay = (event) => {
    if (document.querySelector(".side-menu__menu-item.active")) {
      this.handleMobileMenuBack(event);
      this.setState({
        showMobileMenuDropdown: false,
      });
    }
    this.handleMobileMenu(event);
  };
  render() {
    return (
      <React.Fragment>
        <header id="header">
          <UpperHeader
            clickUpperLogOn={this.handleUpperLogOn}
            clickedOutside={this.handleClickOutsideLogOn}
            isUpperLogOnActive={this.state.showUpperLogOn}
            upperLogonRef={this.upperLogon}
          />
          <LowerHeader
            clickMobileMenu={this.handleMobileMenu}
            clickLowerLogOn={this.handleLowerLogOn}
            isLowerLogOnActive={this.state.showLowerLogOn}
            lowerLogonRef={this.lowerLogon}
            hoverOverNavMenu={this.handleNavDropDownMenu}
            clickOnNavMenu={this.handleNavDropDownMenuFocus}
          />
        </header>
        <MobileMenu
          showMobileMenu={this.state.showMobileMenu}
          clickMobileMenuBack={this.handleMobileMenuBack}
          clickMobileMenuItem={this.handleMobileMenuExtension}
          isMobileMenuDropdownActive={this.state.showMobileMenuDropdown}
          clickMobileMenOverlay={this.handleClickOnOverlay}
        />
      </React.Fragment>
    );
  }
}

// This is the Upper Header component
// This contains everything for the top bar of header
const UpperHeader = (props) => (
  <div className="upper-header">
    <div className="upper-header__inner">
      <div className="upper-header__left">
        <div className="upper-header__left-item upper-header__left--active">
          <a href="/">Personal</a>
        </div>
        <div className="upper-header__left-item">
          <a href="https://www.business.hsbc.com.au/en-au">Corporate</a>
        </div>
        <div className="upper-header__left-item">
          <a href="https://www.gbm.hsbc.com/">Global Banking and Markets</a>
        </div>
        <div className="upper-header__left-item">
          <a href="https://www.privatebanking.hsbc.com/">Private Banking</a>
        </div>
      </div>
      <div className="upper-header__right">
        <div className="upper-header__right-item">English</div>
        <div className="upper-header__right-item">
          <a href="/register/">Register</a>
          <i className="icon icon-chevron-right "></i>
        </div>
        <div
          className="upper-header__right-item upper-header__log-on"
          onClick={props.clickUpperLogOn}
          ref={props.upperLogonRef}
        >
          Log On
          {!props.isUpperLogOnActive ? (
            <i className="icon icon-chevron-down "></i>
          ) : (
            <i className="icon icon-chevron-up "></i>
          )}
          <div className="upper-header__log-on-menu">
            <ul>
              <li>
                <a href="https://www.services.online-banking.hsbc.com.au/gpib">
                  Online Banking{" "}
                  <i className="icon icon-chevron-right-small"></i>
                </a>
              </li>
              <li>
                <a href="https://www.sharetrading.hsbc.com.au/">
                  HSBC Share Trading{" "}
                  <i className="icon icon-chevron-right-small"></i>
                </a>
              </li>
              <li>
                <a
                  className="login-link"
                  href="https://www.hsbc.com.au/ccol/#/login/1"
                >
                  Credit Cards Online{" "}
                  <i className="icon icon-chevron-right-small"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// This is the Lower Header component
// This contains everything for the lower section of header including the dropdowns
const LowerHeader = (props) => (
  <div className="lower-header">
    <div className="lower-header__inner">
      <div className="lower-header__hamburger" onClick={props.clickMobileMenu}>
        <i className="icon icon-menu"></i>
        <span>Menu</span>
      </div>
      <div className="lower-header__logo">
        <img src={logo} alt="logo" />
      </div>
      <div
        className="lower-header__menu-item"
        onMouseEnter={props.hoverOverNavMenu}
        onMouseLeave={props.hoverOverNavMenu}
        onClick={props.clickOnNavMenu}
      >
        <h2 className="lower-header__menu-title">Banking</h2>
        <p className="lower-header__menu-subtitle">Accounts &amp; credit cards</p>
        <div className="lower-header__dropdown-menu">
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
            <a href="/accounts/transactions/">
                <h3>Transaction accounts</h3>
              </a>
              <a href="/accounts/products/everyday-global/">
                <p>Everyday Global Account</p>
              </a>
              <a href="/accounts/products/day-to-day/">
                <p>Day to Day Account</p>
              </a>
              <a href="/accounts/products/visa-debit">
                <p>Visa Debit Card</p>
              </a>
              <a href="/accounts/">
                <p>Learn about bank accounts</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
              <a href="/accounts/savings/">
                <h3>Savings accounts</h3>
              </a>
              <a href="/accounts/products/everyday-savings/">
                <p>Everyday Savings</p>
              </a>
              <a href="/accounts/products/bonus-savings/">
                <p>Bonus Savings</p>
              </a>
              <a href="/accounts/products/term-deposits/">
                <p>Term deposits</p>
              </a>
              <a href="/accounts/">
                <p>Learn about saving</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
            <a href="/credit-cards/">
                <h3>Credit Cards</h3>
                </a>
              <a href="/credit-cards/products/platinum/balance-transfer/">
                <p>Platinum Credit Card</p>
              </a>
              <a href="/credit-cards/products/platinum-qantas/">
                <p>Platinum Qantas Credit Card</p>
              </a>
              <a href="/credit-cards/products/low-rate/">
                <p>Low Rate Credit Card</p>
              </a>
              <a href="/credit-cards/products/premier/">
                <p>Premier Credit Card</p>
              </a>
              <a href="/credit-cards/compare/">
                <p>Compare all credit cards</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
              <h3>Interest Free</h3>
              <a href="/credit-cards/interest-free/">
                <p>HSBC Interest Free</p>
              </a>
              <a href="/credit-cards/products/classic/retailer-sign-up/">
                <p>Become a retail partner</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
                <h3>HSBC Premier</h3>
              <a href="/premier/">
                <p>What is HSBC  Premier</p>
              </a>
              <a href="/premier/#pp_main_title_2">
                <p>Apply for HSBC Premier</p>
              </a>
              <a href="/international/global-view-and-global-transfers/">
                <p>Premier's global benefits</p>
              </a>
              <a href="/accounts/products/premier-childrens-savings/">
                <p>Premier children's account</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col lower-header__dropdown-menu-col--dark">
            <div className="lower-header__dropdown-menu-links">
               <h3>Already bank with us?</h3>
                <a href="https://www.security.online-banking.hsbc.com.au/gsa/SECURITY_LOGON_PAGE/">
                <p>Access online banking</p>
                </a>
                  <a href="/rewards/">
                <p>Credit card rewards</p>
                 </a>
                <a href="/accounts/products/visa-debit/faq/">
                <p>Activate a visa debit card</p>
                 </a>
                <a href="/credit-cards/activate-new-card/">
                <p>Activate a credit card</p>
                </a>
                <a href="/credit-cards/features/additional-cardholder/">
                <p>Add an additional cardholder</p>
                 </a>
                <a href="/help/query-transaction/">
                <p>Query a transaction</p>
                </a>
                <a href="/help/security-centre/fraud/">
                <p>Fraud assistance</p>
                </a>
                </div>
              <div className="lower-header__dropdown-menu-links">
              <a href="/retrieve/">
              <h3>Retrieve an application</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="lower-header__menu-item"
        onMouseEnter={props.hoverOverNavMenu}
        onMouseLeave={props.hoverOverNavMenu}
        onClick={props.clickOnNavMenu}
      >
        <h2 className="lower-header__menu-title">Borrowing</h2>
        <p className="lower-header__menu-subtitle">Home &amp; personal loans</p>
        <div className="lower-header__dropdown-menu">
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">  
              <h3>Buying property</h3>
              <a href="/home-loans/first-home-buyer/">
                <p>First home buyers</p>
              </a>
              <a href="/home-loans/property-investment/">
                <p>Investing</p>
              </a>
              <a href="https://www.hsbc.com.au/home-loans/refinance/">
                <p>Refinancing</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
                <h3>Tools &amp; Calculators</h3>
              <a href="/calculators/home-loan-borrowing-power/">
                <p>How much can I borrow</p>
              </a>
              <a href="/calculators/home-loan-repayment/">
                <p>Repayment calculator</p>
              </a>
              <a href="/calculators/stamp-duty/">
                <p>Stamp duty calculator</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
            <h3>Home Loans</h3>
            <a href="/home-loans/products/fixed-rate/">
                <p>Fixed rate</p>
              </a>
              <a href="/home-loans/products/home-value/">
                <p>Home Value loan</p>
              </a>
              <a href="/home-loans/products/variable-rate/">
                <p>Variable rate</p>
              </a>
              <a href="/home-loans/">
                <p>See all home loans</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
               <a href="/loans/">
               <h3>Loans</h3>
               </a>
              <a href="/loans/products/personal/">
                <p>Personal loans</p>
              </a>
              <a href="/loans/products/renovation/">
                <p>Renovation loans</p>
              </a>
              <a href="/loans/products/debt-consolidation/">
                <p>Debt consolidation</p>
              </a>
              <a href="/loans/products/car/">
                <p>Car loans</p>
              </a>
              <a href="/loans/products/">
                <p>See all loans</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col lower-header__dropdown-menu-col--dark">
            <div className="lower-header__dropdown-menu-links">
            <h3>Already borrow with us?</h3>
              <a href="/home-loans/products/rates/">
                <p>See our home loan rates</p>
              </a>
              <a href="/help/money-worries/">
                <p>Loan repayment support</p>
              </a>
              <a href="/insurance/products/home/">
                <p>Home insurance</p>
              </a>
              <a href="/insurance/products/landlord/">
                <p>Landlord insurance</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
              <a href="/retrieve/">
              <h3>Retrieve an application</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="lower-header__menu-item"
        onMouseEnter={props.hoverOverNavMenu}
        onMouseLeave={props.hoverOverNavMenu}
        onClick={props.clickOnNavMenu}
      >
        <h2 className="lower-header__menu-title">Investing</h2>
        <p className="lower-header__menu-subtitle">Trading &amp; insights</p>
        <div className="lower-header__dropdown-menu">
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
            <h3>Online Trading</h3>
              <a href="/investments/worldtrader/">
                <p>HSBC WorldTrader</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
            <h3>Accredited Investors</h3>
                <a href="/investments/accredited-investor/">
                <p>Why become accredited</p>
                </a>
                <a href="/investments/accredited-investor/how-to-qualify/">
                <p>How to qualify</p>
                </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
            <a href="/investments/">
                <h3>Investment Products</h3>
              </a>
              <a href="/investments/products/share-trading/">
                <p>Australian shares</p>
              </a>
              <a href="/investments/products/exchange-traded-funds/">
                <p>Exchange traded funds</p>
              </a>
              <a href="/investments/products/managed-funds/">
                <p>Managed Funds</p>
              </a>
              <a href="/investments/products/bonds/">
                <p>Bonds</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
            <h3>Other investments</h3>
              <a href="/home-loans/property-investment/">
                <p>Property</p>
              </a>
              <a href="/accounts/products/term-deposits/">
                <p>Term deposits</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
            <h3>Insurance</h3>
              <a href="/insurance/products/home/">
                <p>Home &amp; Contents</p>
              </a>
              <a href="/insurance/products/landlord/">
                <p>Landlord</p>
              </a>
              <a href="/insurance/products/car/">
                <p>Car</p>
              </a>
              <a href="/insurance/claims/">
                <p>Make a claim</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col lower-header__dropdown-menu-col--dark">
            <div className="lower-header__dropdown-menu-links">
            <h3>Already invest with us?</h3>
            <a href="https://www.sharetrading.hsbc.com.au/">
                <p>Log into your account</p>
              </a>
              <a href="https://www.sharetrading.hsbc.com.au/research/ideas/">
                <p>Access research &amp; tools</p>
              </a>
              <a href="https://www.sharetrading.hsbc.com.au/market/">
                <p>Market news &amp; insights</p>
              </a>
              <a href="https://www.sharetrading.hsbc.com.au/wrap/">
                <p>Portfolio reporting</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
              <a href="/retrieve/">
              <h3>Retrieve an application</h3>
              </a>
              </div>
          </div>
        </div>
      </div>
      <div
        className="lower-header__menu-item"
        onMouseEnter={props.hoverOverNavMenu}
        onMouseLeave={props.hoverOverNavMenu}
        onClick={props.clickOnNavMenu}
      >
        <h2 className="lower-header__menu-title">International</h2>
        <p className="lower-header__menu-subtitle">Foreign exchange &amp; relocating</p>
        <div className="lower-header__dropdown-menu">
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
            <h3>Moving to Australia</h3>
              <a href="/international/open-an-australian-bank-account/">
                <p>Opening an account</p>
              </a>
              <a href="/international/studying/">
                <p>Studying in Australia</p>
              </a>
              <a href="/international/moving-to-australia/">
                <p>Living in Australia</p>
              </a>
              <a href="/international/investing/property/">
                <p>Buying property in Australia</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
            <h3>Overseas banking</h3>
                <a href="/international/overseas-account-opening/">
                <p>Opening accounts overseas</p>
                </a>
                <a href="https://internationalservices.hsbc.com/">
                <p>International services</p>
                </a>
              </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
            <a href="/foreign-exchange/">
              <h3>Foreign exchange</h3>
              </a>
              <a href="/foreign-exchange/foreign-currency-accounts/">
                <p>Multicurrency accounts</p>
              </a>
              <a href="https://www.hsbc.com.au/foreign-exchange/international-transfers/">
                <p>International payments</p>
              </a>
              <a href="/foreign-exchange/real-time-rates/">
                <p>Real time rates calculator</p>
              </a>
              <a href="/foreign-exchange/fx-service/">
                <p>Foreign Exchange Desk</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
              <h3>HSBC Premier</h3>
              <a href="/premier/">
                <p>What is HSBC Premier</p>
              </a>
              <a href="/premier/#pp_main_title_2">
              <p>Apply for HSBC Premier</p>
              </a>
              <a href="/international/global-view-and-global-transfers/">
                <p>Premier's global benefits</p>
              </a>
              <a href="/accounts/products/premier-childrens-savings/">
                <p>Premier children's Account</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col lower-header__dropdown-menu-col--dark">
            <div className="lower-header__dropdown-menu-links">
            <h3>Already bank with us?</h3>
              <a href="/international/open-an-australian-bank-account/">
                <p>Open a new account</p>
              </a>
              <a href="/foreign-exchange/international-transfers/">
                <p>Send money overseas</p>
              </a>
              <a href="/ways-to-bank/online-banking/global-transfers/">
                <p>Premier global transfer</p>
              </a>
              <a href="/foreign-exchange/fx-service/">
                <p>Call the Markets desk</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="lower-header__menu-item"
        onMouseEnter={props.hoverOverNavMenu}
        onMouseLeave={props.hoverOverNavMenu}
        onClick={props.clickOnNavMenu}
      >
        <h2 className="lower-header__menu-title">Help &amp; Support</h2>
        <p className="lower-header__menu-subtitle">Services &amp; security</p>

        <div className="lower-header__dropdown-menu">
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
              <h3>Get in touch</h3>
              <a href="/branch-finder/">
                <p>Branch finder</p>
              </a>
              <a href="/help/contact/">
                <p>Contact us</p>
              </a>
              <a href="/ways-to-bank/support/live-chat/">
                <p>Live chat</p>
              </a>
              <a href="/help/feedback-and-complaints/">
                <p>Feedback and complaints</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
              <h3>Extra Care</h3>
              <a href="/help/money-worries/">
                <p>Money worries</p>
              </a>
              <a href="/help/extra-care/">
                <p>Support resources</p>
              </a>
            </div>            
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
              <h3>Ways to bank</h3>
              <a href="/ways-to-bank/mobile-banking/">
                <p>Mobile banking</p>
              </a>
              <a href="/ways-to-bank/online-banking/">
                <p>Online banking</p>
              </a>
              <a href="/ways-to-bank/phone-banking/">
                <p>Phone banking</p>
              </a>
              <a href="/help/switch-to-hsbc/">
                <p>Switching to HSBC</p>
              </a>
            </div>
            <div className="lower-header__dropdown-menu-links">
              <h3>How to guides</h3>
              <a href="/ways-to-bank/online-banking/move-money/">
                <p>Move money</p>
              </a>
              <a href="/ways-to-bank/online-banking/global-transfers/">
                <p>Global transfers</p>
              </a>
              <a href="/ways-to-bank/online-banking/bpay-and-payments/">
                <p>BPAY and payments</p>
              </a>
              <a href="/ways-to-bank/mobile-banking/apple-pay/">
                <p>Using Apple Pay</p>
              </a>
              <a href="/ways-to-bank/mobile-banking/google-pay/">
                <p>Using Google Pay</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col">
            <div className="lower-header__dropdown-menu-links">
              <h3>Fraud, scams &amp; security</h3>
              <a href="/help/security-centre/fraud/contact/">
                <p>What to do if you've been scammed</p>
              </a>
              <a href="/help/security-centre/fraud/">
                <p>Protecting yourself from scams</p>
              </a>
              <a href="/help/security-centre/fraud/common-fraud-and-scams/">
                <p>Common types of scams</p>
              </a>
              <a href="/help/security-centre/safeguard/">
                <p>HSBC Safeguard</p>
              </a>
              <a href="/ways-to-bank/security/">
                <p>Online banking security</p>
              </a>
            </div>
          </div>
          <div className="lower-header__dropdown-menu-col lower-header__dropdown-menu-col--dark">
            <div className="lower-header__dropdown-menu-links">
              <h3>Already bank with us?</h3>
              <a href="/ways-to-bank/support/">
                <p>Online banking support</p>
              </a>
              <a href="/help/query-transaction/">
                <p>Query a transaction</p>
              </a>
              <a href="/ways-to-bank/support/digital-secure-key/">
                <p>Your Digital Secure Key</p>
              </a>
              <a href="/ways-to-bank/online-banking/estatements/">
                <p>Setting up eStatements</p>
              </a>
              <a href="/ways-to-bank/maintenance-schedule/">
                <p>Maintenance schedule</p>
              </a>
              <a href="/help/forms/">
                <p>Find a form</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="lower-header__log-on"
        onClick={props.clickLowerLogOn}
        ref={props.lowerLogonRef}
      >
        <span>Log On</span>
        {!props.isLowerLogOnActive ? (
          <i className="icon icon-chevron-down "></i>
        ) : (
          <i className="icon icon-chevron-up "></i>
        )}
        <div className="lower-header__log-on-menu">
          <ul>
            <li>
              <a href="https://www.services.online-banking.hsbc.com.au/gpib">
                Online Banking <i className="icon icon-chevron-right-small"></i>
              </a>
            </li>
            <li>
              <a href="https://www.sharetrading.hsbc.com.au/">
                HSBC Share Trading{" "}
                <i className="icon icon-chevron-right-small"></i>
              </a>
            </li>
            <li>
              <a
                className="login-link"
                href="https://www.hsbc.com.au/ccol/#/login/1"
              >
                Credit Cards Online{" "}
                <i className="icon icon-chevron-right-small"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

// This is the Mobile Menu component
// This contains everything regarding the mobile menu including the dropdowns/side panels
const MobileMenu = (props) => (
  <div className={`side-menu ${props.showMobileMenu ? "" : "menu-hide"}`}>
    <div className="side-menu__menu">
      <div className="side-menu__menu-item" onClick={props.clickMobileMenuItem}>
        {!props.isMobileMenuDropdownActive ? (
          <i className="icon icon-banking"></i>
        ) : (
          <span onClick={props.clickMobileMenuBack} className="left-arrow">
            <i className="icon icon-chevron-left"></i>
          </span>
        )}
        <p>Banking</p>
        <i className="icon icon-chevron-right-small "></i>
        <div className="side-menu__menu-open">
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
            <a href="/accounts/transactions/">
                <h3>Transaction accounts</h3>
              </a>
              <a href="/accounts/products/everyday-global/">
                <p>Everyday Global Account</p>
              </a>
              <a href="/accounts/products/day-to-day/">
                <p>Day to Day Account</p>
              </a>
              <a href="/accounts/products/visa-debit">
                <p>Visa Debit Card</p>
              </a>
              <a href="/accounts/">
                <p>Learn about bank accounts</p>
              </a>
            </div>
            <div className="side-menu__menu-links">
              <a href="/accounts/savings/">
                <h3>Savings accounts</h3>
                </a>
              <a href="/accounts/products/everyday-savings/">
                <p>Everyday Savings</p>
              </a>
              <a href="/accounts/products/bonus-savings/">
                <p>Bonus Savings</p>
              </a>
              <a href="/accounts/products/term-deposits/">
                <p>Term deposits</p>
              </a>
              <a href="/accounts/">
                <p>Learn about saving</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <a href="/credit-cards/">
                <h3>Credit Cards</h3>
                </a>
              <a href="/credit-cards/products/platinum/balance-transfer/">
                <p>Platinum Credit Card</p>
              </a>
              <a href="/credit-cards/products/platinum-qantas/">
                <p>Platinum Qantas Credit Card</p>
              </a>
              <a href="/credit-cards/products/low-rate/">
                <p>Low Rate Credit Card</p>
              </a>
              <a href="/credit-cards/products/premier/">
                <p>Premier Credit Card</p>
              </a>
              <a href="/credit-cards/compare/">
                <p>Compare all credit cards</p>
              </a>
            </div>
            <div className="side-menu__menu-links">
              <h3>Interest Free</h3>
              <a href="/credit-cards/interest-free/">
                <p>HSBC Interest Free</p>
              </a>
              <a href="/credit-cards/products/classic/retailer-sign-up/">
                <p>Become a retail partner</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
                <h3>HSBC Premier</h3>
              <a href="/premier/">
                <p>What is HSBC  Premier</p>
              </a>
              <a href="/premier/#pp_main_title_2">
                <p>Apply for HSBC Premier</p>
              </a>
              <a href="/international/global-view-and-global-transfers/">
                <p>Premier's global benefits</p>
              </a>
              <a href="/accounts/products/premier-childrens-savings/">
                <p>Premier children's account</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col side-menu__menu-col--dark">
            <div className="side-menu__menu-links">
            <h3>Already bank with us?</h3>
                <a href="https://www.security.online-banking.hsbc.com.au/gsa/SECURITY_LOGON_PAGE/">
                <p>Access online banking</p>
                </a>
                  <a href="/rewards/">
                <p>Credit card rewards</p>
                 </a>
                <a href="/accounts/products/visa-debit/faq/">
                <p>Activate a visa debit card</p>
                 </a>
                <a href="/credit-cards/activate-new-card/">
                <p>Activate a credit card</p>
                </a>
                <a href="/credit-cards/features/additional-cardholder/">
                <p>Add an additional cardholder</p>
                 </a>
                <a href="/help/query-transaction/">
                <p>Query a transaction</p>
                </a>
                <a href="/help/security-centre/fraud/">
                <p>Fraud assistance</p>
                </a>
            </div>
            <div className="side-menu__menu-links">
            <div className="lower-header__dropdown-menu-links">
              <a href="/retrieve/">
              <h3>Retrieve an application</h3>
              </a>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div className="side-menu__menu-item" onClick={props.clickMobileMenuItem}>
        <i className="icon icon-borrowing "></i>
        <p>Borrowing</p>
        <i className="icon icon-chevron-right-small "></i>
        <div className="side-menu__menu-open">
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <h3>Buying property</h3>
              <a href="/home-loans/first-home-buyer/">
                <p>First home buyers</p>
              </a>
              <a href="/home-loans/property-investment/">
                <p>Investing</p>
              </a>
              <a href="https://www.hsbc.com.au/home-loans/refinance/">
                <p>Refinancing</p>
              </a>
            </div>
            <div className="side-menu__menu-links"> 
                <h3>Tools &amp; Calculators</h3>
                <a href="/calculators/home-loan-borrowing-power/">
                 <p>How much can I borrow</p>
                 </a>
                 <a href="/calculators/home-loan-repayment/">
                 <p>Repayment calculator</p>
                 </a>
                 <a href="/calculators/stamp-duty/">
                 <p>Stamp duty calculator</p>
                 </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
            <h3>Home Loans</h3>
            <a href="/home-loans/products/fixed-rate/">
                <p>Fixed rate</p>
              </a>
              <a href="/home-loans/products/home-value/">
                <p>Home Value loan</p>
              </a>
              <a href="/home-loans/products/variable-rate/">
                <p>Variable rate </p>
              </a>
              <a href="/home-loans/">
                <p>See all home loans</p>
              </a>
            </div>
            <div className="side-menu__menu-links">
              <a href="/loans/">
               <h3>Loans</h3>
              </a>
              <a href="/loans/products/personal/">
                <p>Personal loans</p>
              </a>
              <a href="/loans/products/renovation/">
                <p>Renovation loans</p>
              </a>
              <a href="/loans/products/debt-consolidation/">
                <p>Debt consolidation</p>
              </a>
              <a href="/loans/products/car/">
                <p>Car loans</p>
              </a>
              <a href="/loans/products/">
                <p>See all loans</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col side-menu__menu-col--dark">
            <div className="side-menu__menu-links">
            <h3>Already borrow with us?</h3>
              <a href="/home-loans/products/rates/">
                <p>See our home loan rates</p>
              </a>
              <a href="/help/money-worries/">
                <p>Loan repayment support</p>
              </a>
              <a href="/insurance/products/home/">
                <p>Home insurance</p>
              </a>
              <a href="/insurance/products/landlord/">
                <p>Landlord insurance</p>
              </a>
              </div>
              <div className="lower-header__dropdown-menu-links">
              <a href="/retrieve/">
              <h3>Retrieve an application</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="side-menu__menu-item" onClick={props.clickMobileMenuItem}>
        <i className="icon icon-investment"></i>
        <p>Investing</p>
        <i className="icon icon-chevron-right-small "></i>
        <div className="side-menu__menu-open">
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
            <h3>Online Trading</h3>
              <a href="/investments/worldtrader/">
                <p>HSBC WorldTrader</p>
              </a>
            </div>
             <div className="side-menu__menu-links">
                <h3>Accredited Investors</h3>
                <a href="/investments/accredited-investor/">
                <p>Why become accredited</p>
                </a>
                <a href="/investments/accredited-investor/how-to-qualify/">
                <p>How to qualify</p>
                </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
            <a href="/investments/">
                <h3>Investment Products</h3>
              </a>
              <a href="/investments/products/share-trading/">
                <p>Australian shares</p>
              </a>
              <a href="/investments/products/exchange-traded-funds/">
                <p>Exchange traded funds</p>
              </a>
              <a href="/investments/products/managed-funds/">
                <p>Managed Funds</p>
              </a>
              <a href="/investments/products/bonds/">
                <p>Bonds</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-links">
            <h3>Other investments</h3>
              <a href="/home-loans/property-investment/">
                <p>Property</p>
              </a>
              <a href="/accounts/products/term-deposits/">
                <p>Term deposits</p>
              </a>
            </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
            <h3>Insurance</h3>
              <a href="/insurance/products/home/">
                <p>Home &amp; Contents</p>
              </a>
              <a href="/insurance/products/landlord/">
                <p>Landlord</p>
              </a>
              <a href="/insurance/products/car/">
                <p>Car</p>
              </a>
              <a href="/insurance/claims/">
                <p>Make a claim</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col side-menu__menu-col--dark">
            <div className="side-menu__menu-links">
            <h3>Already invest with us?</h3>
            <a href="https://www.sharetrading.hsbc.com.au/">
                <p>Log into your account</p>
              </a>
              <a href="https://www.sharetrading.hsbc.com.au/research/ideas/">
                <p>Access research &amp; tools</p>
              </a>
              <a href="https://www.sharetrading.hsbc.com.au/market/">
                <p>Market news &amp; insights</p>
              </a>
              <a href="https://www.sharetrading.hsbc.com.au/wrap/">
                <p>Portfolio reporting</p>
              </a>
            </div>
            <div className="side-menu__menu-links">
            <a href="/retrieve/">
              <h3>Retrieve an application</h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="side-menu__menu-item" onClick={props.clickMobileMenuItem}>
        <i className="icon icon-international"></i>
        <p>International</p>
        <i className="icon icon-chevron-right-small "></i>
        <div className="side-menu__menu-open">
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
            <h3>Moving to Australia</h3>
              <a href="/international/open-an-australian-bank-account/">
                <p>Opening an account</p>
              </a>
              <a href="/international/studying/">
                <p>Studying in Australia</p>
              </a>
              <a href="/international/moving-to-australia/">
                <p>Living in Australia</p>
              </a>
              <a href="/international/investing/property/">
                <p>Buying property in Australia</p>
              </a>
            </div>
              <div className="side-menu__menu-links">
                <h3>Overseas banking</h3>
                <a href="/international/overseas-account-opening/">
                <p>Opening accounts overseas</p>
                </a>
                <a href="https://internationalservices.hsbc.com/">
                <p>International services</p>
                </a>
              </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
            <a href="/foreign-exchange/">
              <h3>Foreign exchange</h3>
              </a>
              <a href="/foreign-exchange/foreign-currency-accounts/">
                <p>Multicurrency accounts</p>
              </a>
              <a href="/foreign-exchange/international-transfers/">
                <p>International payments</p>
              </a>
              <a href="/foreign-exchange/real-time-rates/">
                <p>Real time rates calculator</p>
              </a>
              <a href="/foreign-exchange/fx-service/">
                <p>Foreign Exchange Desk</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
                <h3>HSBC Premier</h3>
              <a href="/premier/">
                <p>What is HSBC Premier</p>
              </a>
              <a href="/premier/#pp_main_title_2">
              <p>Apply for HSBC Premier</p>
              </a>
              <a href="/international/global-view-and-global-transfers/">
                <p>Premier's global benefits</p>
              </a>
              <a href="/accounts/products/premier-childrens-savings/">
                <p>Premier children's Account</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col side-menu__menu-col--dark">
            <div className="side-menu__menu-links">
            <h3>Already bank with us?</h3>
              <a href="/international/open-an-australian-bank-account/">
                <p>Open a new account</p>
              </a>
              <a href="/foreign-exchange/international-transfers/">
                <p>Send money overseas</p>
              </a>
              <a href="/ways-to-bank/online-banking/global-transfers/">
                <p>Premier global transfer</p>
              </a>
              <a href="/foreign-exchange/fx-service/">
                <p>Call the Markets desk</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="side-menu__menu-item" onClick={props.clickMobileMenuItem}>
        <i className="icon icon-help "></i>
        <p>Help &amp; Support</p>
        <i className="icon icon-chevron-right-small "></i>
        <div className="side-menu__menu-open">
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <h3>Get in touch</h3>
              <a href="/branch-finder/">
                <p>Branch finder</p>
              </a>
              <a href="/help/contact/">
                <p>Contact us</p>
              </a>
              <a href="/ways-to-bank/support/live-chat/">
                <p>Live chat</p>
              </a>
              <a href="/help/feedback-and-complaints/">
                <p>Feedback and complaints</p>
              </a>
            </div>
            <div className="side-menu__menu-links">
              <h3>Extra Care</h3>
              <a href="/help/money-worries/">
                <p>Money worries</p>
              </a>
              <a href="/help/extra-care/">
                <p>Support resources</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <h3>Ways to bank</h3>
              <a href="/ways-to-bank/mobile-banking/">
                <p>Mobile banking</p>
              </a>
              <a href="/ways-to-bank/online-banking/">
                <p>Online banking</p>
              </a>
              <a href="/ways-to-bank/phone-banking/">
                <p>Phone banking</p>
              </a>
              <a href="/help/switch-to-hsbc/">
                <p>Switching to HSBC</p>
              </a>
            </div>
            <div className="side-menu__menu-links">
              <h3>How to guides</h3>
              <a href="/ways-to-bank/online-banking/move-money/">
                <p>Move money</p>
              </a>
              <a href="/ways-to-bank/online-banking/global-transfers/">
                <p>Global transfers</p>
              </a>
              <a href="/ways-to-bank/online-banking/bpay-and-payments/">
                <p>BPAY and payments</p>
              </a>
              <a href="/ways-to-bank/mobile-banking/apple-pay/">
                <p>Using Apple Pay</p>
              </a>
              <a href="/ways-to-bank/mobile-banking/google-pay/">
                <p>Using Google Pay</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <h3>Fraud, scams &amp; security</h3>
              <a href="/help/security-centre/fraud/contact/">
                <p>What to do if you've been scammed</p>
              </a>
              <a href="/help/security-centre/fraud/">
                <p>Protecting yourself from scams</p>
              </a>
              <a href="/help/security-centre/fraud/common-fraud-and-scams/">
                <p>Common types of scams</p>
              </a>
              <a href="/help/security-centre/safeguard/">
                <p>HSBC Safeguard</p>
              </a>
              <a href="/ways-to-bank/security/">
                <p>Online banking security</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col side-menu__menu-col--dark">
            <div className="side-menu__menu-links">
              <h3>Already bank with us?</h3>
              <a href="/ways-to-bank/support/">
                <p>Online banking support</p>
              </a>
              <a href="/help/query-transaction/">
                <p>Query a transaction</p>
              </a>
              <a href="/ways-to-bank/support/digital-secure-key/">
                <p>Your Digital Secure Key</p>
              </a>
              <a href="/ways-to-bank/online-banking/estatements/">
                <p>Setting up eStatements</p>
              </a>
              <a href="/ways-to-bank/maintenance-schedule/">
                <p>Maintenance schedule</p>
              </a>
              <a href="/help/forms/">
                <p>Find a form</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="side-menu__menu-item">
        <i className="icon icon-settings "></i> English
      </div>
      <div className="side-menu__menu-item" onClick={props.clickMobileMenuItem}>
        <i className="icon icon-circle-info "></i>
        <p>About HSBC</p>
        <i className="icon icon-chevron-right-small "></i>
        <div className="side-menu__menu-open">
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <h3 className="about-hsbc-color">CONTACT HSBC</h3>
              <a href="/help/contact/">
                <p>Enquire online, call or send a message</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <h3 className="about-hsbc-color">FIND A BRANCH</h3>
              <a href="/branch-finder/">
                <p>Find your nearest HSBC branch location</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <h3 className="about-hsbc-color">FREQUENTLY ASKED QUESTIONS</h3>
              <a href="/faqs/">
                <p>See FAQs on our products</p>
              </a>
            </div>
            <div className="side-menu__menu-links">
              <h3 className="about-hsbc-color">ABOUT HSBC</h3>
              <a href="https://www.about.hsbc.com.au/">
                <p className = "about-hsbc">Careers, media, investor and corporate information</p>
              </a>
            </div>
          </div>
          <div className="side-menu__menu-col">
            <div className="side-menu__menu-links">
              <a href="/site-terms/" rel="nofollow">
                <p>Site Terms</p>
              </a>
              <a href="/hyperlink-policy/" rel="nofollow">
                <p>Hyperlink Policy</p>
              </a>
              <a href="/help/cookie-policy/">
                <p>Cookie policy</p>
              </a>
              <a href="/legal/" rel="nofollow">
                <p>Legal &amp; Privacy</p>
              </a>
              <a href="/help/important-notices/" rel="nofollow">
                <p>Important Notices</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="side-menu__menu-item side-menu__menu-item--register">
        <a href="/register/">
          <p>Register</p>
          <i className="icon icon-chevron-right-small "></i>
        </a>
      </div>
    </div>
    <div
      onClick={props.clickMobileMenOverlay}
      className="side-menu__overlay"
    ></div>
  </div>
);

//render MainHeader component - which includes everything
ReactDOM.render(<MainHeader />, document.getElementById("header-main-container"));
